/* eslint-disable react/no-unused-class-component-methods */
import {isNil, isString} from 'lodash';
import PropTypes from 'prop-types';
import * as React from 'react';
import {Form} from 'react-bootstrap';

import GridFilterWrapper from './GridFilterWrapper';
import styles from './GridStatusFilter.less';
import {DynamicFilter} from 'src/js/lib/filtering/filters_definitions';
import {FILTER_TYPE_BOOL} from 'src/js/lib/filtering/filters_definitions_constants';

const STATIC_EMPTY_OBJECT = {};

class GridStatusFilter extends React.PureComponent {
  constructor(props) {
    super(props);
    const {valueGetter} = this.props;

    const status = false;
    this.state = {
      // model that is not changed, unless the filter change is finally submitted
      loadedModel: undefined,
      // model that is changed with each filter change
      currentModel: GridStatusFilter.getFilter({status}, props),
      status,
    };
    this.valueGetter = valueGetter;

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.removeFilter = this.removeFilter.bind(this);
  }

  onChange(event) {
    const {filterModifiedCallback} = this.props;
    const {status} = this.state;
    const newStatus = event.target.checked;
    if (status !== newStatus) {
      this.setState(
        {
          status: newStatus,
        },
        () => {
          // getFilter depends on state, it has to be called in callback
          this.setState(
            (state, props) => ({
              currentModel: GridStatusFilter.getFilter(state, props),
            }),
            () => {
              filterModifiedCallback();
            }
          );
        }
      );
    }
  }

  onSubmit() {
    const {filterChangedCallback} = this.props;
    this.setState(
      (state) => ({
        loadedModel: state.currentModel,
      }),
      () => {
        filterChangedCallback();

        if (this.hidePopUp) {
          this.hidePopUp();
        }
      }
    );
  }

  static getFilter(state, props) {
    const {colDef} = props;
    const {status} = state;
    const BoolFilter = DynamicFilter.getFilterClass(FILTER_TYPE_BOOL);
    return new BoolFilter({
      type: FILTER_TYPE_BOOL,
      property: colDef.field,
      value: status,
    });
  }

  getModel() {
    const {currentModel} = this.state;
    return this.isFilterActive() ? currentModel : null;
  }

  setModel(model) {
    this.setState({
      status: model && model.getValue ? model.getValue() : false,
      loadedModel: model || STATIC_EMPTY_OBJECT,
      currentModel: model || STATIC_EMPTY_OBJECT,
    });
  }

  doesFilterPass(params) {
    const {status} = this.state;
    if (status) {
      const value = this.valueGetter(params.node);
      let statusVal;
      if (!isNil(value)) {
        if (value.value) {
          statusVal = JSON.parse(value.value);
        } else if (isString(value)) {
          statusVal = JSON.parse(value);
        }
      }
      if (!isNil(statusVal)) {
        return statusVal.status;
      }
      return false;
    }
    return true;
  }

  afterGuiAttached(params) {
    this.hidePopUp = params.hidePopup;
  }

  removeFilter() {
    const {filterChangedCallback} = this.props;
    this.setState(
      {
        loadedModel: undefined,
        status: false,
      },
      () => {
        // getFilter depends on state, it has to be called in callback
        this.setState(
          (state, props) => ({
            currentModel: GridStatusFilter.getFilter(state, props),
          }),
          () => {
            filterChangedCallback();
            if (this.hidePopUp) {
              this.hidePopUp();
            }
          }
        );
      }
    );
  }

  isFilterActive() {
    const {status} = this.state;
    return status;
  }

  render() {
    const {colDef} = this.props;
    const {currentModel, loadedModel, status} = this.state;
    const filter = currentModel;
    return (
      <div className={styles.dlGridStatusFilter}>
        <GridFilterWrapper
          filter={filter}
          isActive={this.isFilterActive()}
          isEmpty={false}
          label={colDef.headerName}
          loadedModel={loadedModel}
          removeFilter={this.removeFilter}
          submitFilter={this.onSubmit}
          showValue={false}
        >
          {() => (
            <Form.Check
              ref={(elem) => {
                this.elem = elem;
              }}
              tabIndex={0}
              type='checkbox'
              size='sm'
              className={styles.dlGridStatusFilterInput}
              value={status}
              checked={status}
              onChange={this.onChange}
              onKeyDown={this.handleKeyDown}
            />
          )}
        </GridFilterWrapper>
      </div>
    );
  }
}

GridStatusFilter.displayName = 'GridStatusFilter';

GridStatusFilter.propTypes = {
  colDef: PropTypes.objectOf(PropTypes.any).isRequired,
  filterChangedCallback: PropTypes.func.isRequired,
  filterModifiedCallback: PropTypes.func.isRequired,
  valueGetter: PropTypes.func.isRequired,
};

export default GridStatusFilter;
